
import React, { Fragment, useState, useMemo } from 'react';

import ModalHeader from '../../../components/common/headers/ModalHeader';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';
import { FormattedMessage } from 'react-intl/dist';

const TagModal = props => {

    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                id = null,
                name: tagName = '',
                tags,
                handleTagChange
            }
        },
        bottomAnchors: [
            anchor_1,
            anchor_2
        ],
        boundAnchor
    } = props;

    const [ name, updateTagName ] = useState(tagName);

    const isSaveDisabled = useMemo(
        () => tags.some(tag => tag.name.toLowerCase() === name.toLowerCase()) || name === '',
        [ name ]
    );

    const handleSave = () => {
        switch(true){
            case isSaveDisabled:
                return;
            default:
                handleTagChange({ id, name }, undefined); // undefined - for production; 'GET' - for localhost 8888
        }
    };

    const handleChange = ({ target: { value } }) => {
        if(value.length > 60) return;
        updateTagName(value);
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head'>
                <ModalHeader
                    { ...modalHeaderProps }
                    modalHeaderTextData = { id ? 'modals.tag_modal.edit_tag': 'modals.tag_modal.create_tag' }
                />
            </div>
            <div id= 'tagModal' className = 'gi-modal__body'>
                <div className = 'gi-modal__input__label'>
                    <FormattedMessage id = 'modals.tag_name'/>
                </div>
                <input
                    value = { name }
                    onChange = { handleChange }
                    className = 'width-full gi-modal__input__field'
                />
            </div>
            <div className = 'gi-modal__controls'>
                <Button
                    className = 'usa-button gi-button gi-button__secondary'
                    onClick = { hideModal }
                    inputRef = { boundAnchor(anchor_2) }
                >
                    <FormattedMessage id = 'button.close'/>
                </Button>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    disabled = { isSaveDisabled }
                    onClick = { handleSave }
                    inputRef = { boundAnchor(anchor_1) }
                >
                    <FormattedMessage id = 'button.save'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default TagModal;